module.exports = __webpack_public_path__ + "static/6305-woodrose-30-c5fdb7d79fc0bfc15748554d63e92e58.jpg";